import React, { useCallback } from 'react';
import { TTypeOfEditRestaurantModalWindow } from '../../../../../../../editRestaurantState/editRestaurantContext';
import { useAdditionalValidation } from 'components/WithAdditionalValidation/useAdditionalValidation';
import { FileSection } from 'components/UploaderAndDownloader/FileSection';

interface IProps {
	setTlsCertificateFile: ({ fileId, fileHash }: { fileId: Nullable<string>; fileHash: Nullable<string> }) => void;
	changeTypeOfModalWindow: (value: TTypeOfEditRestaurantModalWindow) => void;
	tlsCertificateFileId: Nullable<string>;
	tlsCertificateFilePath: Nullable<string>;
}

const TlsFileSection: React.FC<IProps> = ({
	setTlsCertificateFile,
	changeTypeOfModalWindow,
	tlsCertificateFileId,
	tlsCertificateFilePath,
}) => {
	const { isShowValidationError, validationErrorMessage } = useAdditionalValidation(
		tlsCertificateFileId || tlsCertificateFilePath,
		'shouldUploadTlsCertificate',
		'TlsFileSection',
	);

	const handleDeleteFileId = useCallback(() => {
		setTlsCertificateFile({ fileId: null, fileHash: null });
	}, [setTlsCertificateFile]);

	const handleFileSizeError = useCallback(() => {
		changeTypeOfModalWindow('tlsFileSizeExceeded');
	}, [changeTypeOfModalWindow]);

	const handleFileTypeError = useCallback(() => {
		changeTypeOfModalWindow('tlsFileTypeError');
	}, [changeTypeOfModalWindow]);

	return (
		<FileSection
			onUploadFile={setTlsCertificateFile}
			onDeleteFile={handleDeleteFileId}
			onSizeError={handleFileSizeError}
			onFileTypeError={handleFileTypeError}
			fileId={tlsCertificateFileId}
			filePath={tlsCertificateFilePath}
			fileName="certificate.p12"
			requiredValidationMessage={isShowValidationError ? validationErrorMessage : undefined}
			accept={['p12']}
		/>
	);
};

export default React.memo(TlsFileSection);
